package com.patronat.top.ui.atoms.inputs

import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import com.patronat.top.ui.theme.InputLabelText
import com.patronat.top.ui.theme.MineShaft900
@Composable
fun InputLabel(
    text: String,
    modifier: Modifier = Modifier,
    textStyle: TextStyle = InputLabelText,
    color: Color = MineShaft900
) {
    Text(
        text = text,
        style = textStyle,
        color = color,
        modifier = modifier
    )
}
